import React from 'react';
import { TransfersTab } from '../../components/stores/TransfersTab';

// Site stores: confirm receipt of inbound transfers with a camera photo.
export default function MobileTransfers() {
  return <div className="p-3" data-testid="mobile-transfers-page"><TransfersTab compact inboundOnly /></div>;
}
